<template>
  <div
    class="address__custom__row"
    :class="{
      center: center,
      'button-row': button,
      mobile: mobile
    }"
    @click="handleClick"
  >
    <div class="address__custom__row-icon" v-if="icon">
      <SvgIcon width="24" height="24" :icon="iconName" />
    </div>
    <div v-html="text"></div>
  </div>
</template>

<script>
export default {
  name: 'CustomRow',
  props: {
    text: {
      type: String
    },
    button: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    iconName: {
      type: String,
      default: 'GoogleAddressIcon'
    },
    center: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (this.button) {
        this.$emit('onClick')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.address__custom__row {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  cursor: default;
  color: #21272a;

  &:hover {
    background-color: #f6f6f6;
  }

  &.center {
    justify-content: center;
  }

  &.button-row {
    cursor: pointer;
    color: #21272a;

    &.pin_on_map {
      color: #fa541c;
    }
  }

  .address__custom__row-icon {
    display: flex;
    padding-right: 12px;

    & + div {
      max-width: calc(100% - 42px);
      overflow-x: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &.saved-places-btn {
    .address__custom__row-icon {
      & + div {
        font-weight: 500;
      }
    }
  }
}

.mobile {
  padding: 0 0;

  .address__custom__row-icon {
    margin: 0 16px;
    padding-right: 0;
  }
}
</style>
